module.exports = __webpack_public_path__ + "img/22_29.3f8b2129.png";